import React from 'react'
import { FIELD_NAMES } from 'const/forms'
import { formatDate } from 'helpers/dates'

export default () => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    align: 'center',
  },
  {
    title: 'Kind',
    dataIndex: 'kind',
    key: 'kind',
    width: 120,
    align: 'center',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    width: 150,
    align: 'center',
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    width: 100,
    align: 'center',
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
    width: 80,
    align: 'center',
  },
  {
    title: 'Source',
    dataIndex: 'source_type',
    key: 'source_type',
    width: 80,
    align: 'center',
  },
  {
    title: 'Created at',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 150,
    align: 'center',
    render: formatDate,
  },
  {
    title: 'Expires at',
    dataIndex: 'expires_at',
    key: 'expires_at',
    width: 150,
    align: 'center',
    render: (value) => (value ? formatDate(value) : '-'),
  },
  {
    title: 'Payment date',
    dataIndex: 'payment_date',
    key: 'payment_date',
    width: 150,
    align: 'center',
    render: (value) => (value ? formatDate(value) : '-'),
  },
  {
    title: 'Rule',
    dataIndex: 'rule',
    key: 'rule',
    width: 150,
    align: 'center',
    render: (value) => (value ? `${value.id} - ${value.name}` : '-'),
  },
]
